// removed by extract-text-webpack-plugin
module.exports = {"component":"_1M_QbBHihW5pSv6zyQt_rM","container":"_15C-uid2bUDqumTo6w1hYM","message":"coRY7Jt-jZfpLSAD7jKSi","vcardContainer":"_30yylx89flihH7U5-sItZM","vcardBlock":"a6IdbVCHCBGhyiFc-qvIX","vcard":"vIUw0nxo7sc-v96eePYGh","heading":"BLEpiMKA5VHc6QPKb-xI0","vcardList":"b7fTITULdTEmxeJHJgQNC","vcardListItem":"a_na3pN0zQX_0MPewSPp2","child":"_1KBY6kL1DaotfVdnkPBgQZ","address":"YLSrs_nbYIdAX4V6LTu5r","mapContainer":"_1S3sJez6mM4uX4RJFkGVQA","mapElement":"_1-q-5G8YtNZ_vcXVoM5S5T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/LandingPage/PracticeDetails/PracticeDetails.css
// module id = 1033
// module chunks = 0